import { Controller } from '@hotwired/stimulus'

export default class AccountTypeMappingsController extends Controller<HTMLElement> {
  static targets = ['actions']
  connect() {
    this.actionsTarget.style.setProperty('display', 'none')
  }

  hideActions() {
    this.actionsTarget.style.removeProperty('display')
  }

  resetActions() {
    this.actionsTarget.style.setProperty('display', 'none')
    this.dispatch('reset-on-child')
  }
}
